import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Locale Config',
  basePath: '/locale-config',
  columns: [
    { key: 'code', label: 'Code', sortable: true },
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'country_name_en', label: 'Country (Eng)', sortable: true },
    { key: 'locale', label: 'Locale', sortable: true },
    { key: 'datetime_format', label: 'Datetime format', sortable: true },
    { key: 'rtl', label: 'RTL', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
    { key: 'currency_code', label: 'Currency code', sortable: true },
    { key: 'currency_symbol', label: 'Symbol', sortable: true },
    { key: 'currency_position', label: 'Position', sortable: true },
    { key: 'currency_space', label: 'Space', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'code', label: 'Country code', type: 'text', required: true },
    { key: 'country_name', label: 'Country name', type: 'text' },
    { key: 'country_name_en', label: 'Country name (Eng)', type: 'text' },
    { key: 'locale', label: 'Locale', type: 'text' },
    { key: 'display_locale', label: 'Calendar language (BCP-47, e.g. "en")', type: 'text' },
    { key: 'thousands_separator', label: 'Thousands separator', type: 'text' },
    { key: 'decimal_separator', label: 'Decimal separator', type: 'text' },
    { key: 'grouping', label: 'Grouping', type: 'select',
      options: [
        { label: 'Triplets (3-3-3)', value: 'triplets' },
        { label: 'Indian (3-2-2)', value: 'indian' },
      ] },
    { key: 'date_format', label: 'Date format', type: 'text' },
    { key: 'time_format', label: 'Time format', type: 'text' },
    { key: 'datetime_format', label: 'Datetime format', type: 'text' },
    { key: 'first_day_of_week', label: 'First day of week', type: 'select',
      options: [
        { label: 'Monday (1)', value: '1' },
        { label: 'Sunday (0)', value: '0' },
      ] },
    { key: 'rtl', label: 'RTL', type: 'checkbox' },
    { key: 'currency_code', label: 'Currency code', type: 'text' },
    { key: 'currency_symbol', label: 'Currency symbol', type: 'text' },
    { key: 'currency_position', label: 'Currency position', type: 'select',
      options: [
        { label: 'Before', value: 'before' },
        { label: 'After', value: 'after' },
      ] },
    { key: 'currency_space', label: 'Currency space', type: 'checkbox' },
    { key: 'currency_precision', label: 'Currency precision', type: 'number', defaultValue: 2 },
  ],
  defaultSort: { field: 'code', dir: 'asc' },
});
